import { model } from "core/util";

export const IdentityCardLegacy = model.createModelLegacy("IdentityCard", (json) => ({
    idTypeCode: json.IdTypeCode,
    number: json.Number,
    releaseDate: json.ValidFrom,
    dateOfExpiry: json.ValidTo,
    authority: json.Autority,
}));
